import React, { FC } from 'react';
import { Grid } from '@material-ui/core';

import InternalPosts from './InternalPosts';
import ExternalShares from './ExternalShares';
import MyFollowers from './MyFollowers';

const ActivityCharts: FC = () => (
  <Grid container spacing={3}>
    <Grid item xs={8}>
      <Grid container spacing={2} direction="column">
        <Grid item>
          <ExternalShares />
        </Grid>
        <Grid item>
          <InternalPosts />
        </Grid>
      </Grid>
    </Grid>
    <Grid item xs={4}>
      <MyFollowers />
    </Grid>
  </Grid>
);

export default ActivityCharts;
